module.exports = __webpack_public_path__ + "img/demigods_460.45a412d7.png";